export default __webpack_public_path__ + "static/media/Avenir-Black.6e423be4.woff2";